module.exports = __webpack_public_path__ + "static/media/78.384908c0.png";